<div class="item">
  <ion-checkbox
    class="checkbox"
    [ngClass]="{ disabled: isDisabled }"
    [ngModel]="checked"
    (ngModelChange)="onModelChange($event)"
    [disabled]="isDisabled"
  >
  </ion-checkbox>
  <ion-label class="label"> {{ label }}</ion-label>
</div>
